import {NullOrEmpty} from "data/types/generics";
import {IAxiosApiError, IAxiosErrorMessageObject} from "data/types/api";
import {AxiosError} from "axios";

export function getDashedValue<T>(value: NullOrEmpty<T>, replacer = "-"): string {
	if (value === null || value === undefined) {
		return replacer;
	}
	return String(value);
}

export function getErrorMessageFromAxiosResponse(event: AxiosError<IAxiosApiError, unknown>) {
	if (!event) {
		return "";
	}

	if (!event.response?.data?.errors) {
		return event.message;
	}

	return Object.values(event.response?.data?.errors)
		.map((e: IAxiosErrorMessageObject) => e.message)
		.join(" \n");
}

export const createFanHubEvent = (evtguid: string) => {
	try {
		window.FanHub?.createEvent(evtguid, "687f87bd-bd01-4d6e-8673-cf97ddd461e8");
	} catch (e) {
		console.error(e);
	}
};
